import { useAuthStore } from "@/stores/authStore";
import { Dropdown, type DropdownItem } from "../common/Dropdown";
import { useNavigate } from "react-router-dom";
import { PencomRoutes } from "@/router/PencomRoutes";
import { useQueryClient } from "@tanstack/react-query";

export const EmployeeInfo = () => {
    const { currentEmployer, logout } = useAuthStore();
    const navigate = useNavigate();
    const queryClient = useQueryClient();

    const dropdownItems: DropdownItem[] = [
        {
            id: 'logout',
            label: 'Logout',
            // icon: '',
            onClick: () => {
                // Clear all React Query cache on logout
                queryClient.clear();
                logout();
                navigate(PencomRoutes.LOGIN);
            }
        }
    ];
    return (
        <Dropdown
            trigger={
                <div className="flex flex-row items-center gap-x-3 cursor-pointer">
                    <div className="flex size-10 shrink-0 items-center justify-center rounded-full bg-light-aqua-blue">
                        <p className="text-sm font-semibold font-clash-display leading-none text-dark-green">
                            {currentEmployer?.companyName.slice(0, 2).toUpperCase()}
                        </p>
                    </div>
                    <div className="flex flex-row gap-x-2">
                        <div className="flex flex-col items-start justify-center">
                            <p className="text-md font-semibold font-clash-display text-medium-dark-grey">{currentEmployer?.companyName}</p>
                            <p className="text-md font-regular font-clash-display text-muted-greyish-green">Employer ID: {currentEmployer?.employerCode}</p>
                        </div>
                        <div className="flex flex-col items-center justify-center">
                            <img src={"/assets/icons/dropdown-arrow.svg"} alt="dropdown" />
                        </div>
                    </div>
                </div>
            }
            items={dropdownItems}
        />

    );
};